import React from "react";

import TopicsList from "./TopicsList";
import AdminSearchWidget from "../db-list/AdminSearchWidget";
import ListWrapper from "../../../common/management/ListWrapper";
import ListContentWrapper from "../../../common/management/ListContentWrapper";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

import { genDisplayCount } from "../../../utils/GeneralUtils";
import { useGetTopicsAdmin } from "../../../utils/useTopics";

type Props = {
  handleSearch?: (search: Array<string>) => void;
  handleStatus?: (status: string) => void;
  currentPage: number;
  perView: number;
  search?: Array<string>;
  status?: string | string[];
};

const TopicsListContainer: React.FC<Props> = ({
  handleSearch,
  handleStatus,
  currentPage,
  perView,
  search,
  status,
}) => {
  const auth_token = useAppSelector(getAuthToken);

  const {
    topicsData: {
      items: topics,
      authors,
      total_entries: entries,
      total_pages: totalPage,
    },
    isLoading,
  } = useGetTopicsAdmin({
    auth_token: auth_token,
    page: currentPage,
    per: perView,
    search: search?.join(" "),
    status: status,
  });

  return (
    <ListWrapper pageTitle="トピックス一覧">
      <ListContentWrapper
        isLoading={isLoading}
        displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
        totalEntries={entries}
        totalPage={totalPage}
        currentPage={currentPage}
        handleStatus={handleStatus}
        status={status}
        optionalComponent={
          handleSearch && search ? (
            <AdminSearchWidget handleSearch={handleSearch} search={search} />
          ) : undefined
        }
      >
        <TopicsList topics={topics} authors={authors} />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default TopicsListContainer;
